// supabaseClient.js
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://diypfgzaxyvhezsqxfpf.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRpeXBmZ3pheHl2aGV6c3F4ZnBmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzAzNzk3MjgsImV4cCI6MjA0NTk1NTcyOH0.GfEPcIkc9oIzcA-fXYwnSXpAtvrxjacyDD22IF1prPc'
export const supabase = createClient(supabaseUrl, supabaseKey)
